// extracted by mini-css-extract-plugin
export var fadeInOut = "_1n-3";
export var icon = "_1n-4";
export var savedIndicator = "_1n-2";
export var savingIndicator = "_1n-0";
export var spin = "_1n-1";